import { useEffect, useRef } from "react";
import useSmile from "../../hooks/useSmiles";

interface SmileProps extends React.HTMLAttributes<HTMLCanvasElement> {
  height?: number;
  width?: number;
  smileCode: string;
}

export default function Smile({ smileCode, height = 250, width = 250, ...props }: SmileProps) {
  const { smileTree } = useSmile({ smileCode });
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (!smileTree || !canvasRef.current) return;
    const canvas = canvasRef.current;
    import("smiles-drawer").then((mod) => {
      const drawer = new mod.default.Drawer({ width, height, terminalCarbons: true, explicitHydrogens: true, compactDrawing: false });
      drawer.draw(smileTree, canvas, "light", false);
    });
  }, [smileTree, height, width]);

  return <canvas ref={canvasRef} {...props} />;
}
